import ajax from "../../plugins/ajax";
import Cookies from "js-cookie";

const state = {
  loginInfo: {},
  memberInfo: {},
  classify: [],
  sjzlVersion: null,
  routePath: null,
  userPayOrderAuth: false,
  integralInfo: {}, // 积分信息
};

const mutations = {
  setLoginInfo(state, loginInfo) {
    state.loginInfo = loginInfo;
  },
  setMemberInfo(state, data) {
    state.memberInfo = data;
  },
  setSjzlVersion(state, data) {
    state.sjzlVersion = data;
  },

  setUserPayOrderAuth(state, data) {
    state.userPayOrderAuth = data;
  },
  setClassify(state, data) {
    state.classify = data;
  },
  setRoutePath(state, data) {
    state.routePath = data;
  },

  setIntegral(state, data) {
    state.integralInfo = data;
  },
};

const getters = {
  paid(state) {
    // FIXME 用于调试免费版
    // return false;
    return state.sjzlVersion === 1;
  },
  isNew(state) {
    // 旧版   APPKEY: 4893750
    // 卖家端ERP1，大泽云ERP智慧版    APPKEY: 6825427
    // 卖家端ERP2，大泽云ERP(买家版)  APPKEY: 2706410
    return [6825427, 2706410].includes(Number(state.loginInfo.Appkey));
  },
};

const actions = {
  setLoginInfoAsync({ commit }, data) {
    commit("setLoginInfo", data);
  },
  GetLoginInfo({ commit }, token) {
    localStorage.setItem("dzyunaccess", token);
    ajax.post("api/Member/GetLoginInfo", {}).then((res) => {
      if (res.AliId) {
        if (res.ConfirmService) {
          // 去主页
          commit("setLoginInfo", res);
          setToken(res.Appkey);
          // location.href = "#/index";
        } else {
          // 去确认页
          location.href = "#/useHelp";
        }
      } else {
        // 去授权页
        location.href = "#/loginAuth";
      }
    });
  },
  setMemberInfoAsync({ commit }, data) {
    ajax.post("app/auth/getmemberInfoV2", { _isSjzl: true }).then((res) => {
      commit("setMemberInfo", res);
      dazeTask.login(res.AliId);
    });
  },
  setSjzlVersionAsync({ commit }, data) {
    ajax.post("app/api/judge/sjzlversion", { _isSjzl: true }).then((res) => {
      commit("setSjzlVersion", res.Data);
    });
  },
  setClassifyAsync({ commit }, data) {
    ajax.post("app/ali/classifyjson", { _isSjzl: true }).then((res) => {
      commit("setClassify", res);
    });
  },

  setUserPayOrderAuthAsync({ commit }, data) {
    ajax.post("api/UserPayOrderAuth/VailUserPayOrderAuth", { _isERP: true }).then((res) => {
      commit("setUserPayOrderAuth", res);
    });
  },

  setIntegralAsync({ commit }) {
    // 获取积分
    ajax.post("valueAddedService/api/v1/Recharge/SearchQuantity", { _isSjzl: true }).then((res) => {
      commit("setIntegral", res.result);
    });
  },
};

function setToken(appkey) {
  const isProd = location.host.includes("erp.fjdaze.com");

  ajax
    .post("/api/Auth/GetAccessTokenByOcc?appKey=" + appkey, {})
    .then((res) => {
      localStorage.setItem("erp_accessToken", res.AccessToken);
      Cookies.set("S_Tools_A_Key", res.AccessToken, {
        domain: isProd ? ".fjdaze.com" : ".fjdaze.cn",
      });
      Cookies.set("DZ_ALI_OCC_TOKEN_KEY", res.AccessToken, {
        domain: isProd ? ".fjdaze.com" : ".fjdaze.cn",
      });
      // 刷新页面 去掉code 刷新页面
      location.href = "#/index";
    })
    .catch((err) => {});
}

export default {
  state,
  getters,
  mutations,
  actions,
};
